class ProductCard extends HTMLElement {
    constructor() {
        super();

        this.swatch_ele = this.querySelectorAll('.product-color-swatch-wrapper .swatch')
        this.variant_item = this.querySelectorAll('.variant_list .variant_item.active .item')
        this.add_cart_btn = this.querySelector('add-cart-button')
        this.active_color
        this.enable_color_ga4 = true
        this.item_name = document.getElementById('ProductGridContainer').dataset.itemName
    }
    connectedCallback() {
        this.show_hide_color()
        this.init()
    }
    show_hide_color() {
        this.swatch_ele.forEach(swatch => {
            swatch.classList.remove('hidden');
        })
        this.querySelectorAll('.variant_list .variant_item .item:not(.active)').forEach(variant => {
            this.swatch_ele.forEach(swatch => {
                if (swatch.getAttribute('data').indexOf(variant.getAttribute('data')) > -1) {
                    swatch.classList.add('hidden');
                }
            })
        })
    }

    isVariantAnable() {
        const that = this
        const other_color_swatch = this.querySelectorAll(`.product-color-swatch-wrapper .swatch.hidden[data*='${this.active_color}']`)
        const first_variants = this.querySelectorAll('.variant_list .variant_item.active')[0]
        const last_variants = this.querySelectorAll('.variant_list .variant_item.active')[1]
        // 第一个非size变体
        if (first_variants) {
            for (const variant of first_variants.querySelectorAll('.item:not(.active)')) {
                let color_item = this.querySelector(`.product-color-swatch-wrapper .swatch[data = '${that.active_color} / ${variant.getAttribute('data')}']`)
                if (last_variants) {
                    const last_variants_active = last_variants.querySelector('.item.active').getAttribute('data')
                    color_item = this.querySelector(`.product-color-swatch-wrapper .swatch[data = '${that.active_color} / ${variant.getAttribute('data')} / ${last_variants_active}']`)
                }
                if (color_item) {
                    variant.classList.remove('disabled')
                } else {
                    variant.classList.add('disabled')
                }

            }
        }
        // 第二个非size变体
        if (last_variants) {
            const first_variants_active = first_variants.querySelector('.item.active').getAttribute('data')
            for (const variant of last_variants.querySelectorAll('.item:not(.active)')) {
                const color_item = this.querySelector(`.product-color-swatch-wrapper .swatch[data = '${that.active_color} / ${first_variants_active} / ${variant.getAttribute('data')}']`)
                if (color_item) {
                    variant.classList.remove('disabled')
                } else {
                    variant.classList.add('disabled')
                }

            }
        }
    }

    ga4Event() {
        const product_sku = this.querySelector('.swatch.active').dataset.sku
        const price = this.querySelector('.price.active .cur_price').textContent.slice(1)
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            "event": "ga4Event",
            "event_name": 'select_item',
            "event_parameters": {
                "currency": "CAD",
                "value": price,
                "button": 'image',
                "item_list_id": this.item_name,
                "item_list_name": this.item_name,
                "items": [
                    {
                        "item_list_id": this.item_name,
                        "item_list_name": this.item_name,
                        "item_id": product_sku,
                        "item_name": getProductInfo(product_sku).title,
                        "discount": 0,
                        "index": this.closest('.grid__item').dataset.index,
                        "item_category": getProductInfo(product_sku).name,
                        "item_category2": getProductInfo(product_sku).size,
                        "item_category3": getProductInfo(product_sku).color,
                        "item_variant": getProductInfo(product_sku).type,
                        "item_brand": "SHOKZ",
                        "price": price,
                        "quantity": 1,
                        "currency": "CAD"
                    }
                ]
            }
        });
    }

    init() {

        let that = this

        // 如果是促销状态，显示促销时的标签，隐藏分非促销标签
        if (document.querySelector('.section_colllection_fitler').classList.contains('on_sale')) {
            const onSaleTag = this.querySelector('.custom_tag.on_sale')
            if (onSaleTag) {
                Array.from(onSaleTag.parentElement.children).forEach(tag => {
                    tag.classList.contains('on_sale') ? tag.style.display = 'block' : tag.style.display = 'none'
                })
            }
        }


        // 获取所有颜色选择器元素
        this.swatch_ele.forEach(swatch => {
            // 为每个选择器添加点击事件
            swatch.addEventListener('click', function () {
                // 移除所有兄弟元素的active类，为当前元素添加active类
                const siblings = Array.from(this.parentElement.children);
                siblings.forEach(sib => sib.classList.remove('active'));
                this.classList.add('active');

                // 获取当前的color值，如果其他变体项没有该color，设为disabled
                that.active_color = this.getAttribute('data').split('/')[0].trim()

                that.isVariantAnable()

                // 获取variant_id
                const variantId = this.dataset.id;

                // 处理价格显示
                const topWrapper = this.closest('.top_wrapper');
                const priceElements = topWrapper.querySelectorAll('.price_list .price');
                priceElements.forEach(price => {
                    if (price.dataset.id === variantId) {
                        price.classList.add('active');
                    } else {
                        price.classList.remove('active');
                    }
                });

                // 处理图片显示
                const productItem = this.closest('.product_item');
                const variantImages = productItem.querySelectorAll('.variant-img');
                variantImages.forEach(img => {
                    if (img.dataset.id === variantId) {
                        img.classList.remove('hidden');
                    } else {
                        img.classList.add('hidden');
                    }
                });

                // 更新加入购物车按钮的data属性
                that.add_cart_btn.dataset.variantId = variantId;
                if (that.add_cart_btn.dataset.discontinuedid.indexOf(variantId) > -1 || that.add_cart_btn.dataset.discontinuedhandle == 'true') {
                    that.add_cart_btn.classList.remove('notify')
                    that.add_cart_btn.classList.add('disabled')
                    that.add_cart_btn.querySelector('span').textContent = 'Discontinued'
                } else if (this.dataset.varavailable == 'false') {
                    that.add_cart_btn.classList.add('notify')
                    that.add_cart_btn.querySelector('span').textContent = 'Notify Me'
                } else {
                    that.add_cart_btn.classList.remove('disabled', 'notify')
                    // that.add_cart_btn.querySelector('span').textContent = 'Add To Cart'

                    that.add_cart_btn.querySelector('span').textContent = 'Add To Cart'


                    that.add_cart_btn.classList.remove('hidden')
                }

                if (that.enable_color_ga4) {
                    window.dataLayer.push({ event_parameters: null });
                    window.dataLayer.push({
                        event: 'ga4Event',
                        event_name: 'select_content',
                        event_parameters: {
                            content_type: 'color',
                            button_name: this.getAttribute('data').split('/')[0].trim(),
                        },
                    });
                }
                that.enable_color_ga4 = true
            });
        });

        // 获取所有变体项元素并添加点击事件

        this.variant_item.forEach(item => {
            item.addEventListener('click', function (e) {

                // 给当前项添加active类，移除兄弟项的active类
                const siblings = Array.from(this.parentElement.children);
                siblings.forEach(sib => sib.classList.remove('active'));
                this.classList.add('active');

                that.show_hide_color()


                // 查找符合条件的第一个swatch元素并触发点击事件
                const color_items = this.closest('.variant_list').querySelector('.product_color_item.active .product-color-swatch-wrapper')
                const targetSwatch = color_items.querySelector(`.swatch:not(.hidden)[data*='${that.active_color}']`) || color_items.querySelector(`.swatch:not(.hidden)`)

                //选择size禁止触发color埋点
                that.enable_color_ga4 = false

                // 如果找到元素则触发点击
                if (targetSwatch) {
                    targetSwatch.click();
                }
                if (e.isTrusted) {
                    window.dataLayer.push({ event_parameters: null });
                    window.dataLayer.push({
                        event: 'ga4Event',
                        event_name: 'select_content',
                        event_parameters: {
                            content_type: this.closest('.variant_item').querySelector('.variant_name').textContent,
                            button_name: this.textContent,
                        },
                    });
                }

            });
        });

        // 触发一次改变状态
        // this.querySelector('.product-color-swatch-wrapper .swatch.active').click();

        this.querySelector('.notify_dialog .close').addEventListener('click', function () {
            this.parentElement.classList.add('hidden')
        })

        // 图片跳转埋点
        this.querySelector('.product_top').addEventListener('click', function () {
            that.ga4Event()
        })


        // 特殊处理：默认选中变体
        this.querySelector(".swatch[data-id='44043747786952']")?.click()
        this.querySelector(".swatch[data-id='44602028687560']")?.click()
        this.querySelector(".swatch[data-id='39330540847203']")?.click() // openmove Blue
        this.querySelector(".swatch[data-id='42807973281891']")?.click() // refurbished-openrunpro Pink / Standard
        this.querySelector(".product_info.refurbished-openrun")?.querySelector(".item[data='Mini']")?.click() // Mini Magnetic
        this.querySelector(".product_info.openmeet")?.querySelector(".item[data='USB-A']").click()
    }
} customElements.define("product-item", ProductCard);



/**
 * AddCartButton，加购按钮，点击元素本身触发
 * 
 * Attributes:
 * @param {String} data-variant-id 产品变体 ID
 * @param {String} data-quantity 购买数量，可选，默认为1
 * 
 * @example 
 * ```html
 * <add-cart-button data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
 *   Add to cart
 *   {%- render 'loading-spinner' -%}
 * </add-cart-button>
 * ```
 */
if (!customElements.get('add-cart-button')) {
    class AddCartButton extends ProductCard {
        // 标记
        _marks = {
            loading: "loading"
        };

        _shopify_features_script = document.querySelector("script[id='shopify-features']");
        _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
        _checkout_headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
        };

        get _variantId() { return this.getAttribute("data-variant-id") }
        get _quantity() { return this.getAttribute("data-quantity") ?? 1 }

        constructor() {
            super();
        }

        connectedCallback() {
            this.elements = {
                loadingSpinner: this.querySelector(".loading__spinner"),
            };
            let that = this
            this.addEventListener('click', (e) => {
                if (that.className.indexOf('disabled') > -1) {
                    this.ga4Event('select_item', 'discontinued')
                    return
                } else if (that.className.indexOf('notify') > -1) {
                    that.nextElementSibling.classList.remove('hidden')
                    this.ga4Event('select_item', 'notify me')
                } else {
                    this.startLoading();
                    this.addToCart().finally(() => {
                        this.finishLoading();
                    });
                    this.ga4Event('add_to_cart', 'add to cart')
                }
            });
        }



        // 埋点
        ga4Event(eventName, buttonName) {
            const product_sku = this.closest('.top_wrapper').querySelector('.swatch.active').dataset.sku
            const price = this.closest('.top_wrapper').querySelector('.price.active .cur_price').textContent.slice(1)
            const comp_price = this.closest('.top_wrapper').querySelector('.price.active .compare_price')?.textContent.slice(1) || 0
            let discount = comp_price && parseFloat(comp_price) > parseFloat(price) ? parseFloat(comp_price) - parseFloat(price) : 0
            discount = Math.floor(discount)
            window.dataLayer.push({ "event_parameters": null });
            window.dataLayer.push({
                "event": "ga4Event",
                "event_name": eventName,
                "event_parameters": {
                    "currency": "CAD",
                    "value": price,
                    "button": buttonName,
                    "item_list_id": this.item_name,
                    "item_list_name": this.item_name,
                    "items": [
                        {
                            "item_list_id": this.item_name,
                            "item_list_name": this.item_name,
                            "item_id": product_sku,
                            "item_name": getProductInfo(product_sku).title,
                            "discount": discount,
                            "index": this.closest('.grid__item').dataset.index,
                            "item_category": getProductInfo(product_sku).name,
                            "item_category2": getProductInfo(product_sku).size,
                            "item_category3": getProductInfo(product_sku).color,
                            "item_variant": getProductInfo(product_sku).type,
                            "item_brand": "SHOKZ",
                            "price": price,
                            "quantity": 1,
                            "currency": "CAD"
                        }
                    ]
                }
            });
        }

        /**
         * 加购
         */
        async addToCart() {
            let data_json = {
                form_type: "product",
                quantity: this._quantity,
                utf8: "✓",
                id: this._variantId,
            }
            let data = JSON.stringify(data_json);
            return fetch("/cart/add.json",
                {
                    method: 'POST',
                    headers: this._checkout_headers,
                    body: data
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }
            }).then((response) => {
                return this.updateCart(response);
            }).catch((err) => {
                console.error(err);
            });
        }

        /**
         * 更新购物车，并弹出侧边购物车
         * @returns 
         */
        async updateCart(response) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
                // source: 'product-form',
                productVariantId: this._variantId,
                cartData: response,
            });
            document.querySelector("cart-drawer").open();

            if ($(".cart-items").length < 1) {
                $(`cart-drawer`).removeClass("is-empty");
                $(".drawer__inner-empty").remove();
                $("#CartDrawer-Checkout").removeAttr("disabled");
            }
        }

        startLoading() {
            this.setAttribute("aria-disabled", true);
            this.classList.add(this._marks.loading);
            this.elements.loadingSpinner?.classList.remove("hidden");
        }

        finishLoading() {
            this.removeAttribute("aria-disabled");
            this.classList.remove(this._marks.loading);
            this.elements.loadingSpinner?.classList.add("hidden");
        }
    }

    customElements.define('add-cart-button', AddCartButton);
}

